import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { BillingPanel, type BillingSearch } from "@/components/settings/BillingPanel";
import { SettingsNav } from "@/components/settings/SettingsNav";

export const Route = createFileRoute("/settings/billing")({
  validateSearch: (s: Record<string, unknown>): BillingSearch => ({
    checkout: s.checkout === "monthly" || s.checkout === "annual" ? s.checkout : undefined,
    promo: typeof s.promo === "string" ? s.promo : undefined,
    status: s.status === "success" || s.status === "cancelled" ? s.status : undefined,
  }),
  component: BillingPage,
});

function BillingPage() {
  const navigate = useNavigate();
  const search = Route.useSearch();
  const goBack = () => {
    if (window.history.length > 1) window.history.back();
    else navigate({ to: "/dashboard" });
  };

  return (
    <div className="mx-auto max-w-2xl space-y-6 p-6">
      <SettingsNav />
      <header>
        <button
          onClick={goBack}
          className="mb-2 flex items-center gap-1 text-[11px] text-muted-foreground transition-colors hover:text-foreground"
        >
          <ArrowLeft className="size-3" /> Back
        </button>
        <h1 className="text-xl font-medium">Billing</h1>
        <p className="mt-1 text-sm text-muted-foreground">Manage your PaperChase plan.</p>
      </header>
      <BillingPanel {...search} />
    </div>
  );
}
